<template>
  <div class="relationOur">
   <!-- 快捷菜单 -->

   <card-plate title="联系我们">
     <!-- <span slot="headMore"><span>更多>></span></span> -->
     <div slot="headCont" class="relationOur-cont">
      <div class="relationOur-item" >
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/Qcode1.png" alt="">
        <p class="relationOur-p-col">一链公众号</p>
      </div>
      <div class="relationOur-item" >
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/Qcode2.png" alt="">
        <p class="relationOur-p-col">福星购企业微信</p>
      </div>
     </div>
   </card-plate>

  </div>
</template>
<script>
import Cookies from "js-cookie";
import {mapActions} from 'vuex';
import cardPlate from './cardPlate.vue'
export default {
  props: [],
  components: {
    'card-plate': cardPlate
  },
  data () {
    return {
      menuList:[]
    }
  },
  mounted () {
    // this.findAllDashboardNavs()
  },
  methods: {

  }
}
</script>
<style>
.relationOurMenu .cardPlate-cont{
  padding: 0;
}
.relationOur-cont{
  padding: 15px 0;
  max-height: 185px;
  overflow: auto;
  display: flex;
}
.relationOur-cont .relationOur-item{
  width: 50%;
  text-align: center;
}
.relationOur-cont .relationOur-item img{
  width: 108px;
  margin-bottom: 8px;
}
.relationOur-cont::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

.relationOur-cont::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.relationOur-cont::-webkit-scrollbar-thumb {
  -webkit-border-radius: 4px;
  border-radius: 4px;
  background: rgba(0,0,0,0.3);
}

.relationOur-cont::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0,0,0,0.2);
}
.relationOur-cont .cardPlate-cont {
    max-height: 265px;
    overflow: auto;
}
.relationOur-cont .relationOur-p-col{
  font-size: 12px;
  color: #909399;
  letter-spacing: 0;
  text-align: center;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/relationOur.vue